package io.eqoty.shared.viewmodel

import kotlinx.browser.window

actual fun HandlePlatformPushState() {
    window.history.pushState("{}", "")
}